import * as React from "react"
import { useQuery } from '@tanstack/react-query'
import { fetchMovie, fetchDirector } from './api'

function useMovie(title) {
  return useQuery({
    queryKey: ['movie', title],
    queryFn: async () => fetchMovie(title),
  })
}

function useDirector(id) {
  return useQuery({
    queryKey: ['director', id],
    queryFn: async () => fetchDirector(id),
    enabled: id !== undefined
  })
}

function useMovieWithDirectorDetails(title) {
  const movie = useMovie(title)
  const directorId = movie.data?.director
  const director = useDirector(directorId)

  return {
    movie,
    director
  }
}

function Movie({ title }) {
  const { movie, director } = useMovieWithDirectorDetails(title)

  if (movie.status === 'pending') {
    return <div>...</div>
  }

  if (movie.status === 'error') {
    return <div>Error fetching {title}</div>
  }

  return (
    <p>
      Title: {movie.data.title} ({movie.data.year})
      <br />
      { director?.data
        ? <> Director: {director.data.name}</>
        : null
      }
    </p>
  )
}

export default function App() {
  return (
    <>
      <Movie title="The Godfather" />
      <Movie title="The Godfather Part II" />
    </>
  )
}